export const eurosToCredits = euros => (euros ? euros / 1000 : 0);

export const creditsToEuros = credits => (credits ? credits * 1000 : 0);

export const addSpaces = num =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, '');
